import logger from '../../../utils/logger';
import { DeviceStatus } from '../../../constants/DeviceStatus';
import { Material } from '../../../../types/api/Material';
import { Device } from '../../../../types/api/Device';
import { ToleranceMode } from '../../../constants/Configuration';
import {
  getRunMode,
  isRunModeNewYork,
} from '../run-mode';

export const updateDeviceStatuses = (
  batchStore: any,
  materialStore: any,
  originalBins: Device[],
  substituteBins: Device[],
  scaleId: string,
  substituteMaterial: Material,
  currentWeight: number,
  currentScaleWeight: number,
  deferredWeight: number,
  scaleData: any,
  constituent: any,
  batchData: any,
  substituteAlreadyFed: number = 0,
) => {
  const substituteMaterialCode = materialStore.getMaterialName(substituteMaterial);
  const { configuration } = batchStore.settingsStore;
  const runMode = batchData.runMode || getRunMode(configuration, batchStore);
  const isCumulative = isRunModeNewYork(runMode) || configuration?.toleranceMode === ToleranceMode.NYDOTCumulative;

  for (const originalBin of originalBins) {
    if (batchStore.isHoldFeedDevice(originalBin.id)) {
      batchStore.holdFeedDevices = batchStore.holdFeedDevices.filter((id: any) => id !== originalBin.id);
    }
    batchStore.deviceStatus.set(originalBin.id, {
      ...batchStore.getDeviceStatus(originalBin.id),
      status: DeviceStatus.FINISH,
      substitutionNote: `Material switched to ${substituteMaterialCode}`,
      target: isCumulative ? currentScaleWeight : currentWeight,
      weight: isCumulative ? currentScaleWeight : currentWeight,
      isSubstituted: false,
      substitutionWeight: 0,
      targetIsNet: true,
    });
  }

  const scaleKey = Number(scaleId);
  const currentScaleStatus = batchStore.getDeviceStatus(scaleKey);
  // A pending substitute that was deferred has already put substituteAlreadyFed on the scale. Exclude it from the
  // baseline so that weight counts towards the substitute (its target includes it) instead of being fed again.
  const baseline = currentScaleWeight - substituteAlreadyFed;

  for (const substituteBin of substituteBins) {
    // The substitute bin is parked, not paused mid-feed: its status still describes an earlier feed that was
    // already deducted from inventory, so skip the pause inventory update.
    batchStore.holdFeedDevice(substituteBin.id, false);
    const currentSubstituteBinStatus = batchStore.getDeviceStatus(substituteBin.id);
    const freeFall = substituteBin.id === scaleData.bin.id
      ? 0
      : batchStore.getFreeFall(substituteBin, batchData);
    const target = isCumulative
      ? baseline + scaleData.mft - freeFall
      : scaleData.mft - freeFall;

    logger.log('[DEVICE_STATUS] Setting substitute bin status', {
      substituteBinId: substituteBin.id,
      currentScaleWeight,
      prevWeight: baseline,
      substituteAlreadyFed,
      currentWeight,
      target,
      currentSubstituteBinStatus: currentSubstituteBinStatus,
    });

    batchStore.deviceStatus.set(substituteBin.id, {
      ...currentSubstituteBinStatus,
      prevWeight: baseline,
      weight: isCumulative ? currentScaleWeight : substituteAlreadyFed,
      weightUpdated: 0,
      isSubstituted: true,
      substitutionWeight: scaleData.substitutionWeight,
      targetIsNet: true,
      target,
      status: DeviceStatus.HOLD,
    });
  }

  batchStore.deviceStatus.set(scaleKey, {
    ...currentScaleStatus,
    materialCode: substituteMaterialCode,
    mCode: constituent ? constituent.mixItemCode : substituteMaterialCode,
  });
};
